import * as React from 'react';

import styled from '@emotion/styled';
import { Flex as BaseFlex } from '@lightspeed/flame/Core';
import { Switch } from '@lightspeed/flame/Switch';

const collapsedClass = 'analytics_collapsed';
const errorClass = 'analytics_error';

const Flex = styled(BaseFlex)`
  > * {
    margin-right: 0.42em;
  }
`;

interface Props {
  isCollapsedPref?: boolean;
  onShow?: () => void;
}

export const CollapseSwitch: React.FC<Props> = ({
  isCollapsedPref: _isCollapsed = false,
  onShow = () => {},
}) => {
  const [isCollapsed, setIsCollapsed] = React.useState(_isCollapsed);

  const handleCollapse: React.FormEventHandler<HTMLInputElement> = (event) => {
    const checked = event.currentTarget.checked;
    if (checked) onShow();

    setIsCollapsed(!checked);

    const table = document.querySelector('table.analytics');
    const root = document.querySelector('td.analytics_root') as HTMLTableCellElement;
    if (!table || !root) return;

    if (!checked) {
      window.lsCloud.UserPreferences.save(
        'listing',
        'purchase.listings.items',
        'analytics_collapsed',
        'on'
      );
    } else {
      window.lsCloud.UserPreferences.save(
        'listing',
        'purchase.listings.items',
        'analytics_collapsed',
        'off'
      );
    }
  };

  React.useEffect(() => {
    const table = document.querySelector('table.analytics');
    const root = document.querySelector('td.analytics_root') as HTMLTableCellElement;
    if (!table || !root) return;

    if (isCollapsed) {
      table.classList.add(collapsedClass);
      if (table.classList.contains(errorClass)) root.colSpan = 1;
    } else {
      table.classList.remove(collapsedClass);
      if (table.classList.contains(errorClass)) root.colSpan = 3;
    }
  }, [isCollapsed]);

  return (
    <Flex height="3.78em" alignItems="center">
      <span>Demand forecast view</span>
      <Switch onChange={handleCollapse} defaultChecked={!isCollapsed} />
    </Flex>
  );
};
